<span class="icon-wrap" *ngIf="isRequired()" aria-hidden="true">
<fa-icon icon="exclamation-triangle" title="Currently missing or unverified"></fa-icon>
</span>
